import { useApolloClient } from '@apollo/client';

import SpotlightComplexCollectionDocumentNode from 'bundles/page-config-common/queries/SpotlightComplexCollection.graphql';
import type {
  SpotlightComplexCollectionQuery,
  SpotlightComplexCollectionQueryVariables,
} from 'bundles/page-config-common/queries/__generated__/SpotlightComplexCollection';

export function useQuerySpotlightCollection() {
  const apolloClient = useApolloClient();

  return (props: { queryCollectionId: string; additionalInput: unknown }) => {
    return apolloClient.query<SpotlightComplexCollectionQuery, SpotlightComplexCollectionQueryVariables>({
      query: SpotlightComplexCollectionDocumentNode,
      variables: {
        queryCollectionId: props.queryCollectionId,
        additionalInput: props.additionalInput,
      },
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
    });
  };
}
